
  export default {
    name: "FilterDropdown",
    props: {
      id: String,
      title: String,
      iconSize: { type: Number, default: 20 },
      lightGrey: { type: Boolean, default: true },
      headerText: String,
      allButton: { type: Boolean, default: true },
      allText: String,
      popoverText: String,
      options: Array<string>
    },
    data() {
      return {
        selected: [],
        allSelected: false,
        text: {
          clear: this.$t("clear")
        }
      };
    },
    methods: {
      changeFilter() {
        this.allSelected = this.options.length == this.selected.length;
        this.$emit("changeFilter", this.selected);
      },
      selectAll() {
        if (this.allSelected)
          this.selected = this.options[0].value
            ? this.options.map(opt => opt.value)
            : this.options;
        else this.selected = [];
        this.changeFilter();
      },
      clear() {
        this.selected = [];
        this.changeFilter();
      }
    }
  };
